export function convertNumber(value: number): {
  intoCurrency: string
  intoNormalAmount: string
  withoutDecimal: string
} {
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };

  const withoutDecimal: Intl.NumberFormatOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  };

  return {
    intoCurrency: value.toLocaleString('en-US', options),
    intoNormalAmount: value.toLocaleString('en-US', options),
    withoutDecimal : value.toLocaleString('en-US', withoutDecimal),
  }
}